import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "./Menu";
import MuiMenu from "@material-ui/core/Menu";
import { observable, action, decorate } from "mobx";
import { observer } from "mobx-react";
import ArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { CircularProgress, Checkbox, Switch } from "@material-ui/core";
import AntSwitch from "../AntSwitch";

const styles = {
  subMenuItem: {
    display: "flex",
    justifyContent: "space-between",
  },
};

class SubMenuItem extends React.Component {
  menuOpen = false;
  anchorElement = null;
  menuItems = [];
  isLoading = true;

  constructor(props) {
    super(props);
    this.iconRef = React.createRef();
  }

  setAnchorElement = (node) => {
    // console.lo
    this.anchorElement = node;
  };

  handleItemClick(event) {
    const me = this,
      { parentMenuItem, listId, aliasPrefix } = me.props;

    if (me.menuOpen) {
      return;
    }
    this.clearMouseOverTimer();
    if (event.stopPropagation) {
      event.stopPropagation();
    }

    if (!this.anchorElement) {
      this.setAnchorElement(event.currentTarget);
    }

    this.menuOpen = !this.menuOpen;

    if (me.props.menuItems) {
      me.isLoading = false;
      return;
    }

    this.isLoading = true;
    window.TL.ApiClient.getListConfig({
      list_id: listId,
    }).then({
      success: function (response) {
        if (response.success) {
          // me.targetList = response.data.list;
          let columns = TL.list.settings.lookup.CriteriaHelper.formatListColumns(
            response.data.listData,
            ""
          );
          let idColumn = {
              "id": listId + "_id",
              "list_id": listId,
              "column_type_id": "5",
              "name": "ID",
              "group_id": "0",
              "options": "[{\"decimals\":0}]",
              "alias_name": "id",
              "formula_id": "0",
              "event_handlers": "{\"system\":[],\"user\":[]}",
              "dafault_type": "1",
              "group": null,
              "group_order": null,
              "formula": null,
              "referred_column_ids": null,
              "alias_path": "id",
              "list_name": ""
          };
          columns.unshift(idColumn);
          for (var i = 0; i < columns.length; i++) {
            columns[i]["alias_path"] =
              (aliasPrefix == "" ? "" : aliasPrefix + ".") +
              columns[i]["alias_path"];
            if (parentMenuItem) {
              columns[i]["alias_index"] = parentMenuItem.alias_index;
              columns[i]["list_id"] = parentMenuItem.list_id;
              columns[i]["list_name"] = parentMenuItem.list_name;
              if(columns[i]["name"] == "ID" && columns[i]["dafault_type"] && columns[i]["dafault_type"] == "1") {
                columns[i]["id"] = parentMenuItem.list_id + "_id"
              }
            }

            columns[i]["unique_id"] =
              columns[i]["id"] + "-" + columns[i]["alias_index"];
            if (parentMenuItem && listId == parentMenuItem.list_id) {
              //columns[i]["alias_index"] += (this.columnId ? this.columnId: '');
              columns[i]["unique_id"] += this.columnId
                ? "-" + this.columnId
                : "";
            }
            columns[i]["alias_name"] = columns[i]["alias_path"];       
            if(this.props.isNotificationEnabled) {
              columns[i]["type"] = "column";
            }      
          }

          me.menuItems = columns;
          // me.targetListPermissions = Ext.create("TL.list.permissions.Permissions", {
          // permissions: response.data.listPermissions
          // });
        } else {
          Ext.Msg.alert("Error", response.msg ?? "Error loading list columns");
        }
        this.isLoading = false;
      },
      failure: function () {
        this.isLoading = false;
        Ext.Msg.alert("Error", "Error loading list columns");
      },
      scope: this,
    });
  }

  handleSubMenuClose() {
    this.menuOpen = false;
  }

  onMouseOver(event) {
    let currentTarget = event.currentTarget;

    this.clearMouseOverTimer();
    this.mouseOverTimer = setTimeout(() => {
      this.handleItemClick({
        currentTarget: currentTarget,
      });
    }, this.props.hoverTimeout ?? 500);
  }

  clearMouseOverTimer() {
    if (this.mouseOverTimer) {
      clearTimeout(this.mouseOverTimer);
    }
  }

  onMouseOut(event) {
    this.clearMouseOverTimer();
  }

  addDataToWindows(menuItem){
    let column = menuItem,
      isPercentage = false;
    window.hasOwnProperty("lookupColumnsInfo")
      ? (window.lookupColumnsInfo[menuItem.alias_path] = menuItem)
      : (window["lookupColumnsInfo"] = { [menuItem.alias_path]: menuItem });
    
    if (column.column_type_id == 22) {
      isPercentage = true;
    } else if (column.column_type_id == 10) {
      let options = JSON.parse(column.options);
      if (options && options[0].column_type == "percentage") {
        isPercentage = true;
      }
    }
    if (isPercentage) {
      window.hasOwnProperty("percentageAliases")
        ? window.percentageAliases.push(column.alias_path ? column.alias_path : column.alias_name)
        : (window.percentageAliases = [column.alias_path ? column.alias_path : column.alias_name]);
    }
    
  }

  onMenuItemClick = (menuItem) => {
    if (!this.props.isCheckBox) {
      this.handleSubMenuClose();
    }
    this.addDataToWindows(menuItem)
    this.props.onMenuItemClick(menuItem);
  };

  render() {
    const me = this,
      {
        caption,
        isNotificationEnabled = false,
        menuItems,
        classes,
        onMenuItemClick,
        valueKey,
        displayKey,
        parentMenuItem,
        isCheckBox = false,
        isChecked,
        checkedValues,
        isLoading,
        filterFunction,
        isClickEnablesMenu = false,
      } = this.props;
    // console.log(this.iconRef);
    const options = typeof parentMenuItem?.options === 'string' ? JSON.parse(parentMenuItem.options) : parentMenuItem?.options || [];
    const columnType = options.length > 0 ? options[0].column_type : null;
    return (
      <React.Fragment>
        <MenuItem
          // onMouseOver={this.onMouseOver}
          onClick={
            isClickEnablesMenu
              ? this.handleItemClick
              : () => me.onMenuItemClick(parentMenuItem)
          }
          className={classNames(classes.subMenuItem)}
          style={{
            justifyContent: "flex-start",
          }}
        >
          {isCheckBox && (
            <AntSwitch
              size="small"
              color="primary"
              disabled={ columnType !== "email" && isNotificationEnabled }
              checked={isChecked}
              onChange={() => {
                //dosomething
              }}
            />
          )}
          {caption}
          {isLoading ? (
            <CircularProgress
              style={{
                width: "18px",
                height: "18px",
                right: "5px",
                position: "absolute",
              }}
            />
          ) : (
            <ArrowRightIcon
              ref={this.iconRef}
              style={{
                width: 18,
                height: 18,
                position: "absolute",
                right: 0,
              }}
              onClick={this.handleItemClick}
              onMouseOver={this.onMouseOver}
              onMouseOut={this.onMouseOut}
            />
          )}
        </MenuItem>
        {!this.isLoading ? (
          <Menu
            open={this.menuOpen}
            menuItems={menuItems ?? this.menuItems}
            anchorElement={this.iconRef.current}
            onClose={this.handleSubMenuClose}
            valueKey={valueKey}
            isCheckBox={isCheckBox}
            checkedValues={checkedValues}
            displayKey={displayKey}
            isNotificationEnabled={isNotificationEnabled} 
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            loadingMenuItems={me.props.loadingMenuItems}
            onMenuItemClick={me.onMenuItemClick}
            filterFunction={filterFunction}
            isClickEnablesMenu={me.props.isClickEnablesMenu}
            name={me.props.name}
          />
        ) : (
          <MuiMenu //height issue if loaded without data.. so using this hack
            open={this.menuOpen}
            anchorEl={this.iconRef.current}
            anchorOrigin={{ vertical: "center", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <MenuItem>
              {" "}
              <CircularProgress />{" "}
            </MenuItem>
          </MuiMenu>
        )}
      </React.Fragment>
    );
  }
}

decorate(SubMenuItem, {
  menuOpen: observable,
  anchorElement: observable,
  menuItems: observable,
  isLoading: observable,

  setAnchorElement: action,
  handleItemClick: action.bound,
  handleSubMenuClose: action.bound,
  onMouseOver: action.bound,
  onMouseOut: action.bound,
});

export default withStyles(styles)(observer(SubMenuItem));
